import * as Actions from '../index';
import * as TYPES from '../actions';
import { listQuestionsBySectionId } from '../../../api/queries'
import { API, graphqlOperation } from 'aws-amplify'

export const studentSelectedSectionBeforeReview = (userData) => {
    return {
      type: TYPES.STUDENT_SELECTED_SECTION_BEFORE_REVIEW,
      data: userData,
    };
};